export default [
  {
    kram: 1,
    title: "કમળ",
    axar_audio: "क",
    gujarati_audio: "कमल",
    axar: "ક",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/ka.png",
  },
  {
    kram: 2,
    title: "ખટારો",
    axar_audio: "ख",
    gujarati_audio: "कमल",
    axar: "ખ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/kha.png",
  },
  {
    kram: 3,
    title: "ગણપતિ",
    axar_audio: "ग",
    gujarati_audio: "गणपति",
    axar: "ગ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/ga.png",
  },
  {
    kram: 4,
    title: "ઘર",
    axar_audio: "घ",
    gujarati_audio: "घर",
    axar: "ઘ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/gha.png",
  },
  {
    kram: 5,
    title: "ચકલી",
    axar_audio: "च",
    gujarati_audio: "चकली",
    axar: "ચ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/cha.png",
  },
  {
    kram: 6,
    title: "છત્રી",
    axar_audio: "छ",
    gujarati_audio: "कमल",
    axar: "છ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/chha.png",
  },
  {
    kram: 7,
    title: "જમરૂખ",
    axar_audio: "ज",
    gujarati_audio: "जमरूख",
    axar: "જ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/ja.png",
  },
  {
    kram: 8,
    title: "ઝબલું",
    axar_audio: "झ",
    gujarati_audio: "जबलू",
    axar: "ઝ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/jha.png",
  },
  {
    kram: 9,
    title: "ટપાલી",
    axar_audio: "ट",
    gujarati_audio: "टपाली",
    axar: "ટ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/ta.png",
  },
  {
    kram: 10,
    title: "ઠળિયો",
    axar_audio: "ठ",
    gujarati_audio: "ठलियो",
    axar: "ઠ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/tha.png",
  },
  {
    kram: 11,
    title: "ડાકલું",
    axar_audio: "ड",
    gujarati_audio: "डाकलू",
    axar: "ડ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/da.png",
  },
  {
    kram: 12,
    title: "ઢગલો",
    axar_audio: "ढ",
    gujarati_audio: "ढगलो",
    axar: "ઢ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/dha.png",
  },
  {
    kram: 13,
    title: "ફેણ",
    axar_audio: "ण",
    gujarati_audio: "फेंण",
    axar: "ણ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/ana.png",
  },
  {
    kram: 14,
    title: "તપેલી",
    axar_audio: "त",
    gujarati_audio: "तपेली",
    axar: "ત",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/ta-flat.png",
  },
  {
    kram: 15,
    title: "થડ",
    axar_audio: "थ",
    gujarati_audio: "थड",
    axar: "થ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/tha-flat.png",
  },
  {
    kram: 16,
    title: "દડો",
    axar_audio: "द",
    gujarati_audio: "दड़ो",
    axar: "દ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/da-flat.png",
  },
  {
    kram: 18,
    title: "ધજા",
    axar_audio: "ध",
    gujarati_audio: "ધજા",
    axar: "ધ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/dha-flat.png",
  },
  {
    kram: 18,
    title: "નગારું",
    axar_audio: "न",
    gujarati_audio: "नगारू",
    axar: "ન",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/na.png",
  },
  {
    kram: 19,
    title: "પતંગ",
    axar_audio: "प",
    gujarati_audio: "पतंग",
    axar: "પ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/pa.png",
  },
  {
    kram: 20,
    title: "ફટાકડા",
    axar_audio: "फ",
    gujarati_audio: "फटाकड़ा",
    axar: "ફ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/fa.png",
  },
  {
    kram: 21,
    title: "બતક",
    axar_audio: "ब",
    gujarati_audio: "बतक",
    axar: "બ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/ba.png",
  },
  {
    kram: 22,
    title: "ભમરડો",
    axar_audio: "भ",
    gujarati_audio: "भमरडो",
    axar: "ભ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/bha.png",
  },
  {
    kram: 23,
    title: "મરચું",
    axar_audio: "म",
    gujarati_audio: "मरचु",
    axar: "મ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/ma.png",
  },
  {
    kram: 24,
    title: "યતિશ",
    axar_audio: "य",
    gujarati_audio: "यतीश",
    axar: "ય",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/ya.png",
  },
  {
    kram: 25,
    title: "રમકડા",
    axar_audio: "र",
    gujarati_audio: "रमकड़ा",
    axar: "ર",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/ra.png",
  },
  {
    kram: 26,
    title: "લસણ",
    axar_audio: "ल",
    gujarati_audio: "लसन",
    axar: "લ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/la.png",
  },
  {
    kram: 27,
    title: "વહાણ",
    axar_audio: "व",
    gujarati_audio: "वहाण",
    axar: "વ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/va.png",
  },
  {
    kram: 28,
    title: "શરણાઈ",
    axar_audio: "श",
    gujarati_audio: "शरणाई",
    axar: "શ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/sh.png",
  },
  {
    kram: 29,
    title: "ષટ્કોણ",
    axar_audio: "ष",
    gujarati_audio: "षट्कोण",
    axar: "ષ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/sha.png",
  },
  {
    kram: 30,
    title: "સગડી",
    axar_audio: "स",
    gujarati_audio: "सगड़ी",
    axar: "સ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/sa.png",
  },
  {
    kram: 31,
    title: "હરણ",
    axar_audio: "ह",
    gujarati_audio: "हरण",
    axar: "હ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/ha.png",
  },
  {
    kram: 32,
    title: "નળ",
    axar_audio: "ळ",
    gujarati_audio: "नल",
    axar: "ળ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/na-flat.png",
  },
  {
    kram: 33,
    title: "ક્ષત્રિય",
    axar_audio: "क्ष",
    gujarati_audio: "क्षत्रिय",
    axar: "ક્ષ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/xa.png",
  },
  {
    kram: 34,
    title: "યજ્ઞ",
    axar_audio: "ज्ञ",
    gujarati_audio: "यज्ञ",
    axar: "જ્ઞ",
    image: "bal_vibhag/paku_kariye/gujarati-kakko/yagn.png",
  },
];

